module.exports = __webpack_public_path__ + "static/media/rydz6.7de0a93f.jpeg";